import { Picker } from "emoji-mart";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { useEmojiData } from "./hooks/useEmojiData";

const EmojiPickerMenu = ({ onEmojiSelect }) => {
  const { data } = useEmojiData();
  const { t } = useTranslation();

  const createPicker = ref => {
    new Picker({
      autoFocus: true,
      data,
      native: true,
      onEmojiSelect,
      previewPosition: "none",
      ref: { current: ref },
      skinTonePosition: "none",
      style: { maxWidth: "100%" },
      theme: "light",
    });
  };

  return (
    <div
      aria-label={t("neetoMolecules.common.emojiPicker")}
      ref={createPicker}
      role="dialog"
      style={{ minWidth: "350px" }}
    />
  );
};

EmojiPickerMenu.propTypes = { onEmojiSelect: PropTypes.func };

export default EmojiPickerMenu;
